import React, { useEffect, useState } from 'react';
import { Bar, BarChart } from 'recharts';
import { BsArrowUp } from "react-icons/bs";
import { collection, getCountFromServer } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { useAuth } from '../../../../context/AuthContext';

const PartiesStats = () => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [dataCount, setDataCount] = useState(null);
  const [data, setData] = useState();

  async function getDataCount() {
    const query = collection(db, "Businesses", bid, "Parties");
    const snapshot = await getCountFromServer(query);
    setDataCount(snapshot.data().count);
  }

  useEffect(() => {
    getDataCount();
  }, [dataCount]);

  return (
    <div className='p-3'>
      <h6>Total Parties</h6>
      <div className='row'>
        <div className='col-9'>
          <h2 className='fw-bold'>{dataCount && dataCount}</h2>
          <div className='text-muted d-flex align-items-center'>
            <BsArrowUp size={14} />
            <small className='ms-2'>
              <div className='fw-normal'><span className='text-dark'>+2.5%</span> last 7 days</div>
            </small>
          </div>
        </div>
        <div className='col-3 d-flex justify-content-end'>
          <BarChart width={70} height={40} data={data}>
            <Bar dataKey="uv" fill="var(--bs-orange)" />
          </BarChart>
        </div>
      </div>
    </div>
  );
}

export default PartiesStats;
